import { HealthcareProviderNfzConfiguration } from '@dreryk/egabinet-nfz-configuration-frontend-api';

import { useFormController } from '@dreryk/react-common';

import { NfzConfigurationFormBean, NfzSettingsFormController } from './NfzSettingsForm.types';

type NfzSettingsFormControllerOptions = {
   nfzConfiguration: HealthcareProviderNfzConfiguration | null;
};

const getNfzConfigurationData = (nfzConfiguration: HealthcareProviderNfzConfiguration): NfzConfigurationFormBean => {
   if (nfzConfiguration.contractingPartyType === 'PROVIDER') {
      return {
         nfzDepartment: nfzConfiguration.nfzDepartment,
         contractingPartyType: 'PROVIDER',
         providerCode: nfzConfiguration.providerCode ?? null,
      };
   }

   return {
      nfzDepartment: nfzConfiguration.nfzDepartment,
      contractingPartyType: nfzConfiguration.contractingPartyType,
      providerCode: null,
   };
};

const getInitialValues = (nfzConfiguration: HealthcareProviderNfzConfiguration | null): NfzConfigurationFormBean => {
   if (!nfzConfiguration) {
      return {
         nfzDepartment: null,
      };
   }

   return getNfzConfigurationData(nfzConfiguration);
};

export const useNfzSettingsFormController = (options: NfzSettingsFormControllerOptions): NfzSettingsFormController => {
   return useFormController<NfzConfigurationFormBean>(getInitialValues(options.nfzConfiguration), {
      resetAfterSubmit: true,
   });
};
